export default __webpack_public_path__ + "static/media/radar_claim_qr.f52c0597.png";